import { useEffect, useRef } from "react";
import { Button } from "./Button";

interface ConfirmationProps {
  title: string;
  children: React.ReactNode;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  busy?: boolean;
  confirmDisabled?: boolean;
}

export function Confirmation({ title, children, confirmLabel, onConfirm, onCancel, busy, confirmDisabled = false }: ConfirmationProps) {
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => heading.current?.focus(), []);
  return (
    <section className="confirmation" aria-labelledby="confirmation-title">
      <h2 id="confirmation-title" tabIndex={-1} ref={heading}>{title}</h2>
      <div>{children}</div>
      <div className="action-row">
        <Button variant="danger" onClick={onConfirm} busy={busy} disabled={confirmDisabled}>{busy ? "Requesting deletion…" : confirmLabel}</Button>
        <Button variant="secondary" onClick={onCancel} disabled={busy}>Cancel</Button>
      </div>
    </section>
  );
}
